import React from 'react';
import './SiteFooter.css';

const SiteFooter = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>OUR MISSION</h3>
            <p>Let's build a music community for music creators and their fans to communicate directly. Support each other and share amazing music.</p>
          </div>
          <div className="footer-section">
            <h3>LET'S CONNECT</h3>
            <p>Want to collaborate on a music project or become a strategic partner? Reach out to our team to see how we can help.</p>
            <button className="connect-btn">CONNECT</button>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-left">
            <div className="footer-logo">
              <img src="/logo.png" alt="LIVESTA" />
              <p>Livesta believes in music.</p>
            </div>
            <p className="copyright">©2025 Being Inc.</p>
          </div>
          <div className="footer-right">
            <div className="social-section">
              <h4>Join the community</h4>
                          <div className="social-icons">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://discord.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-discord"></i></a>
            </div>
          </div>
          <div className="footer-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter; 